<div class="can-edit-background">
  <div class="can-edit-title">
    Alert!
  </div>
  <div class="can-edit-info">
    This module has been answered by one or more participants and can no longer be edited or deleted.
  </div>
</div>
